module.exports = __webpack_public_path__ + "img/436.8f1a32cc.png";